enum FEATURE_NAME {
  LANDING_PAGE = "Landing Pages",
}

export default FEATURE_NAME;